import React, { useMemo } from 'react';
import type { Member } from 'src/features/projects/types';

type Props = {
    members: Member[];
    value: string | null; // null이면 "자동(등록자)"
    disabled?: boolean;
    onChange: (v: string | null) => void;

    // 편집 모드에서 “등록자=createdBy”로 되돌리기 옵션 제공
    createdByUserId?: string | null;
};

export default function RiskOwnerSelect({ members, value, disabled, onChange, createdByUserId }: Props) {
    const options = useMemo(() => {
        // user 정보가 없는 member도 있을 수 있으니 방어
        return members
            .map((m) => ({
                userId: m.userId,
                name: m.user?.name ?? '',
                email: m.user?.email ?? '',
                role: m.role ?? '',
            }))
            .sort((a, b) => (a.email || a.userId).localeCompare(b.email || b.userId));
    }, [members]);

    return (
        <div>
            <label className="block text-xs text-gray-600 mb-1">책임자(Owner)</label>

            <select
                className="w-full rounded border px-2 py-1"
                disabled={disabled}
                value={value ?? '__AUTO__'}
                onChange={(e) => {
                    const v = e.target.value;
                    if (v === '__AUTO__') return onChange(null);
                    onChange(v);
                }}
            >
                <option value="__AUTO__">자동(등록자)</option>

                {createdByUserId && <option value={createdByUserId}>등록자(creator)로 설정</option>}

                {options.map((o) => (
                    <option key={o.userId} value={o.userId}>
                        {(o.name || o.email || o.userId).trim()} {o.role ? `(${o.role})` : ''}
                    </option>
                ))}
            </select>

            <div className="mt-1 text-[11px] text-gray-500">
                생성 시 미지정이면 서버가 <b>등록자=책임자</b>로 자동 설정합니다.
            </div>
        </div>
    );
}
